<section class="container-menu">
  <div [routerLink]="['/profile']" class="container-item-menu">
    <img src="assets/icons/icon-my-profile.svg" alt="" class="icon-menu">
    <span class="name-item-menu" > Mi perfl </span>
  </div>
  <!-- <div class="container-item-menu">
    <img src="assets/icons/icon-cupon.svg" alt="" class="icon-menu">
    <span class="name-item-menu" > Agregar cupon </span>
  </div> -->
  <div (click)="closeSession()" class="container-item-menu">
    <img src="assets/icons/icon-close-session.svg" alt="" class="icon-menu">
    <span *ngIf="closingSesion" class="name-item-menu" > Cerrando sesión... </span>
    <span *ngIf="!closingSesion" class="name-item-menu" > Cerrar sesión </span>
  </div>
</section>
